
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 60000, // Increase stale time to 1 minute
      gcTime: 300000, // Cache for 5 minutes (previously cacheTime)
    },
  },
});

